export const state = {
    nfe: {},
    nfes: [],
    nfce: {},
    modalGerarNfe: false,
    modalGerarNfce: false,
    modalEnviarNfeEmail: false,
    modalCancelarNfe: false,
    modalCancelarNfce: false,
    modalEstornoNfe: false,
    modalCartaCorrecaoNfe: false,
    tiposFreteNfe: [
        {
            id: 0,
            descricao: 'Emitente'
        },
        {
            id: 1,
            descricao: 'Destinatário'
        },
        {
            id: 2,
            descricao: 'Terceiros'
        },
        {
            id: 9,
            descricao: 'Sem frete'
        },
    ],
    tiposOperacaoNfe: [
        {
            id: 1,
            descricao: 'Interna'
        },
        {
            id: 2,
            descricao: 'Interestadual'
        },
        // {
        //     id: 3,
        //     descricao: 'Exterior'
        // },
    ],
    formasPagamentoNfe: [
        {
            id: '01',
            descricao: 'Dinheiro' 
        },
        {
            id: '02',
            descricao: 'Cheque' 
        },
        {
            id: '03',
            descricao: 'Cartão de Crédito' 
        },
        {
            id: '04',
            descricao: 'Cartão de Débito' 
        },
        {
            id: '05',
            descricao: 'Crédito Loja' 
        },
        {
            id: '10',
            descricao: 'Vale Alimentação' 
        },
        {
            id: '11',
            descricao: 'Vale Refeição' 
        },
        {
            id: '12',
            descricao: 'Vale Presente' 
        },
        {
            id: '13',
            descricao: 'Vale Combustível' 
        },
        {
            id: '15',
            descricao: 'Boleto Bancário' 
        },
        {
            id: '99',
            descricao: 'Outros' 
        },
    ],
    bandeiraFormasPagamentoNfe: [
        {
            id: '01',
            descricao: 'Visa'
        },
        {
            id: '02',
            descricao: 'MasterCard'
        },
        {
            id: '03',
            descricao: 'American Express'
        },
        {
            id: '04',
            descricao: 'SoroCred'
        },
        {
            id: '05',
            descricao: 'Diners Club'
        },
        {
            id: '06',
            descricao: 'Elo',
        },
        {
            id: '07',
            descricao: 'Hipercard'
        },
        {
            id: '08',
            descricao: 'Aura'
        },
        {
            id: '09',
            descricao: 'Cabal'
        },
        {
            id: '99',
            descricao: 'Outros'
        },
    ]
    
}

export default {}